import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import { useLocation, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import { getPaymentInfo, selectorPayment } from '../../../app/slices/packageSlice'
import styles from './PayResult.module.css'

// const STATUS = {
//   SUCCESS: 'success',
//   FAILED: 'failed',
// }

const useStyles = makeStyles({
  root: {
    padding: '16px',
    margin: '45px auto 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',
    // overflow: 'auto',
    boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.16);',
    width: 492,
    height: 444,
    borderRadius: '10px',
    '@media(max-width: 800px)': {
      margin: '35px auto 10px',
    },
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 32,
    fontWeight: 600,
    color: '#4caf50',
    margin: '15px auto 10px',
    '@media (max-width: 800px)': {
      fontSize: 24,
    },
  },
  failTitle: {
    fontSize: 32,
    fontWeight: 600,
    color: '#ff1f54',
    margin: '15px auto 10px',
    '@media (max-width: 800px)': {
      fontSize: 24,
    },
  },
  title2: {
    fontWeight: 500,
    fontSize: '20px',
    borderBottom: '1px solid #c6c6c6',
    borderWidth: '90px',
    padding: '30px',
    width: '85%',
    textAlign: 'center',
    '@media (max-width: 800px)': {
      fontSize: 14,
      padding: '20px',
    },
  },
  pos: {
    marginBottom: 12,
  },
  cardWrap: {
    padding: '16px',
    margin: '45px auto 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',
    '@media (max-width: 800px)': {
      fontSize: 14,
      margin: '0',
    },
  },
  bodyTitle: {
    fontSize: '20px',
    fontWeight: 500,
    margin: '40px auto 0',
    '@media (max-width: 800px)': {
      fontSize: 14,
      margin: '40px auto 0',
    },
  },
  bodyNumber: {
    fontSize: 32,
    fontWeight: 'bold',
    margin: '10px auto 25px',
    '@media (max-width: 800px)': {
      fontSize: 24,
      margin: '12px auto 20px',
    },
  },
  factorTitle: {
    fontSize: '20px',
    fontWeight: 500,
    marginTop: '12px',
    '@media (max-width: 800px)': {
      fontSize: 14,
      margin: '20px auto 0',
    },
  },
  factorNumber: {
    fontSize: 32,
    fontWeight: 'bold',
    // margin: '15px auto 25px',
    '@media (max-width: 800px)': {
      fontSize: 24,
      // margin: '12px auto 20px',
    },
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexFlow: 'column',

    margin: '0 auto',
    transform: 'translateY(10%)',
    '@media (max-width: 800px)': {
      transform: 'translateY(20%)',
    },
  },
  loginButton: {
    backgroundColor: 'rgba(0, 40, 238, 0.74)',
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: 'normal',
    margin: '57px auto',
  },
})

export default function BankResult({ location }) {
  const classes = useStyles()
  const PayInfo = useSelector(selectorPayment)
  const dispatch = useDispatch()
  // const navigate = useNavigate()
  const useQuery = () => new URLSearchParams(useLocation().search)
  const query = useQuery()

  // const [success, setSuccess] = useState(false)

  useEffect(() => {
    console.log(query.get('success'))

    // setSuccess(query.get('success'))
    dispatch(getPaymentInfo(query.get('paymentId')))
  }, [])
  console.log(PayInfo?.data)
  // const bull = <span className={clclassesasses.bullet}>•</span>

  // const goToProfile = () => {
  //   nav
  // }

  if (query?.get('success')?.toLowerCase() === 'true') {
    return (
      <div className={classes.cardContainer}>
        <Card className={styles.mainPay}>
          <CardContent className={classes.cardWrap}>
            <Typography component="h1" className={classes.title} color="textSecondary">
              پرداخت موفق
            </Typography>
            <Typography className={classes.title2}>
              پرداخت شما با موفقیت انجام شد
            </Typography>
            <hr style={{ color: '#000' }} />
            {/* <Typography variant="body2" component="p" /> */}

            <Typography className={classes.factorTitle} component="h2">
              شناسه فاکتور
            </Typography>
            <Typography className={classes.factorNumber} component="h1">
              {/* {PayInfo.data.id} */}
              {PayInfo?.data?.id}
            </Typography>

            <Typography className={classes.bodyTitle} component="h2">
              شماره پیگیری
            </Typography>
            <Typography className={classes.bodyNumber} component="h1">
              {PayInfo?.data?.saleReferenceId}
            </Typography>
          </CardContent>
        </Card>

        <Button variant="contained" className={classes.loginButton}>
          <Link to="/app" style={{ color: '#fff' }} onClick={() => location.replace('/app')}> ورود به پنل کاربری</Link>
        </Button>
      </div>
    )
  }
  return (
    <div className={classes.cardContainer}>
      <Card className={styles.mainPay}>
        <CardContent className={classes.cardWrap}>
          <Typography component="h1" className={classes.failTitle} color="textSecondary">
            پرداخت ناموفق
          </Typography>
          <Typography className={classes.title2}>
            متاسفانه پرداخت شما با مشکل مواجه شد
          </Typography>
          <hr style={{ color: '#000' }} />
          {/* <Typography variant="body2" component="p" /> */}

          <Typography className={classes.factorTitle} component="h2">
            شناسه فاکتور
          </Typography>
          <Typography className={classes.factorNumber} component="h1">
            {PayInfo?.data?.id}
          </Typography>

          {/* <Typography className={classes.bodyTitle} component="h2">
            شماره پیگیری
          </Typography>
          <Typography className={classes.bodyNumber} component="h1">
            {PayInfo?.data?.SaleReferenceId}
          </Typography> */}

        </CardContent>
      </Card>

      <Button variant="contained" className={classes.loginButton}>
        <Link to="/app" onClick={() => location.replace('/app')} style={{ color: '#fff' }}> ورود به پنل کاربری</Link>
      </Button>
    </div>
  )
}
